export default __webpack_public_path__ + "static/leafBannerSmaller-d913c079ec9ac4439d57f9af1d5dc452.jpg";